module.exports = __webpack_public_path__ + "static/img/pagj_card_bg.058896c4.png";